import { Collapse, Input, Form, Tag } from 'antd'
import { func, object } from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components'

const VariablesWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	border-radius: 2px;
	gap: 4px;
`

const Variables = styled(Tag)`
	font-size: 14px;
	cursor: pointer;
`

const CollapseFields = styled(Collapse)`
	border: 1px solid #d9d9d9;
	margin-bottom: 24px;
`

const PanelCollapse = styled(Collapse.Panel)`
	&& .ant-collapse-header {
		align-items: center;
		display: flex;
	}

	&&& .ant-collapse-content-box {
		padding: 20px 32px;
	}
`

const PanelWrapper = styled.div`
	display: flex;
	flex-direction: column; /* Deixe em coluna para inputs largos */
	row-gap: 16px; /* Espaçamento vertical */
	width: 100%; /* Garante que ocupe toda a largura */
`

const FormItemFields = styled(Form.Item)`
	width: 100%;

	.ant-form-item-label {
		text-align: left;
	}
`

const StructuredFormatted = ({ data, update }) => {
	const { structure, variable } = data
	const { row_template, separator, label } = variable.extra_style_params

	const variablesList = structure
		.filter((item) => item.variable && item.variable.name)
		.map((item) => item.variable.name)

	const [syncValue, setSyncValue] = useState(row_template)
	const [syncLabel, setSyncLabel] = useState(label || '')

	const handleVariableInText = (nVar) => {
		let newValue = `${syncValue} {{ ${nVar} }}`
		setSyncValue(newValue)
		updateVariable(newValue)
	}

	const handleRowTemplateChange = (e) => setSyncValue(e.target.value)
	const handleLabelChange = (e) => setSyncLabel(e.target.value)

	const updateVariable = (newTemplate) => {
		update({
			variable: {
				...variable,
				extra_style_params: {
					...variable.extra_style_params,
					row_template: newTemplate,
				},
			},
		})
	}

	const updateSeparator = (e) => {
		update({
			variable: {
				...variable,
				extra_style_params: {
					...variable.extra_style_params,
					separator: e.target.value,
				},
			},
		})
	}

	const updateLabel = () => {
		update({
			variable: {
				...variable,
				extra_style_params: {
					...variable.extra_style_params,
					label: syncLabel,
				},
			},
		})
	}

	const handleRowTemplateBlur = () => updateVariable(syncValue)
	const handleLabelBlur = () => updateLabel()

	return (
		<CollapseFields ghost defaultActiveKey={[1]}>
			<PanelCollapse key={0} header={<div>Formatação</div>}>
				<PanelWrapper>
					{variablesList.length > 0 && (
						<FormItemFields label="Variáveis adicionadas">
							<VariablesWrapper>
								{variablesList.map((item, i) => (
									<Variables key={i} onClick={() => handleVariableInText(item)}>
										{item}
									</Variables>
								))}
							</VariablesWrapper>
						</FormItemFields>
					)}

					<FormItemFields label="Texto">
						<Input.TextArea
							value={syncValue}
							autoSize={{ minRows: 4, maxRows: 10 }}
							onBlur={handleRowTemplateBlur}
							onChange={handleRowTemplateChange}
							style={{ width: '100%' }}
						/>
					</FormItemFields>

					<FormItemFields label="Separador">
						<Input
							defaultValue={separator}
							onBlur={updateSeparator}
							style={{ width: '100%' }}
						/>
					</FormItemFields>

					<FormItemFields label="Label do elemento">
						<Input
							value={syncLabel}
							onChange={handleLabelChange}
							onBlur={handleLabelBlur}
							placeholder="Ex: Pessoa, Empresa, etc."
							style={{ width: '100%' }}
						/>
					</FormItemFields>
				</PanelWrapper>
			</PanelCollapse>
		</CollapseFields>
	)
}

StructuredFormatted.propTypes = {
	data: object,
	update: func,
}

export default StructuredFormatted
